import React from 'react';
import { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './AzyByteTechLanding.css';
import heroimg from '../assets/heroimg.svg';
import azybytelogo from '../assets/azybytelogocompressed.png';
import unityonehealthcentre from '../assets/unityonehealthcentre.png';
import whatsappautomation from '../assets/whatsappautomation.png';
import royalcrown from '../assets/royalcrown.png'
import Footer from './Footer';
import Navbar from './Navbar';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {Swiper,SwiperSlide} from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from "react-router-dom";
import { blogs } from "../blogs/blogData";
import { Helmet } from 'react-helmet-async';
import FounderSection from './FounderSection';

function AzyByteLanding() {
  //  const text = "Welcome to AzyByte Technologies";
  // const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: true,     // Whether animation should happen only once - while scrolling down
      offset: 100,    // Offset (in px) from the original trigger point
    });
  }, []);

  const reviews = [
    {
      name: "Sabir Uddin",
      role: "Owner, Jewelry Shop",
      text: "AzyByte delivered our e-commerce platform 2 weeks ahead of schedule on wordpress.",
      initial: "S",
      color: "bg-primary"
    },
    {
      name: "Aakash Macwan",
      role: "Vintage Hub Cafe, Nadiad ",
      text: "AzyByte delivered us Food Ordering System with bill generation. Its now easy for customers to place order from the table and get the menu in their phone.",
      initial: "A",
      color: "bg-secondary"
    },
    {
      name: "Mahefuz Mandal",
      role: "Owner, MYS Designs and Prints",
      text: "Got an Whatsapp Automation chatbot which helped my shop to automate the queries of cutomers on whatsapp.",
      initial: "M",
      color: "bg-success"
    }
  ];

  return (

<div>
       <Helmet>
          <title>
            AzyByte Technologies | Web Development, AI Automation & Software Solutions
          </title>

          <meta
            name="description"
            content="AzyByte Technologies delivers custom web development, mobile apps, AI automation, cloud solutions, and digital transformation services for businesses."
          />

          <meta
            name="keywords"
            content="AzyByte Technologies, AzyByte , Web Development Nadiad, Software Development Nadiad, AI Automation, Mobile App Development, MERN Stack Development"
          />

          <link
            rel="canonical"
            href="https://www.azybyte.in/"
          />

          <meta
            property="og:title"
            content="AzyByte Technologies"
          />

          <meta
            property="og:description"
            content="Web Development, AI Automation, Software Solutions and Digital Transformation Services."
          />

          <meta
            property="og:url"
            content="https://www.azybyte.in/"
          />

          <meta
            property="og:type"
            content="website"
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "AzyByte Technologies",
              "alternateName": "AzyByte",
              "url": "https://www.azybyte.in/",
              "logo": "https://www.azybyte.in/azybytelogo.png",
              "description": "AzyByte Technologies delivers custom web development, mobile apps, AI automation, cloud solutions, and digital transformation services.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Nadiad",
                "addressRegion": "Gujarat",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.linkedin.com/company/azybytetechnologies",
                "https://instagram.com/azybytetech"

              ]
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "AzyByte Technologies",
              url: "https://www.azybyte.in/",
              description:
                "Web Development, AI Automation and Software Solutions."
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "How long does it typically take to complete a project?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Project timelines vary depending on the scope and complexity. A simple website might take 2-4 weeks, while a complex web application could take 2-6 months."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is your pricing structure?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer flexible pricing models including fixed-price projects, hourly rates, and retainer arrangements."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you provide ongoing support after project completion?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer maintenance and support packages including updates, bug fixes, feature enhancements, and monitoring."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What technologies do you specialize in?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We specialize in React, Angular, Vue.js, Node.js, Python, PHP, AWS, Azure and modern web technologies."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How do you handle project communication?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We maintain transparent communication through regular meetings, project management tools, and a dedicated project contact."
                  }
                }
              ]
            })}
          </script>
        </Helmet>

      <header>
          <Navbar />
      </header>

  <main>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              {/* <h1 className="text-primary fw-500 mb-3 welcome-text">
                {displayText}
              </h1> */}
              <h2 className="display-4 fw-bold mb-4 heroh1 mobile-h1">
                <span>Advanced Tech Solutions for Modern Businesses</span>
              </h2>
              <p className="lead mb-4 px-2 px-lg-0">
                With AzyByte Technologies, businesses and individuals thrive together.
                We help you navigate the digital landscape.
              </p>

              {/* --- MOBILE ONLY IMAGE --- */}
              {/* Shows on mobile (d-block), hides on Large screens (d-lg-none) */}
              <div className="d-block d-lg-none mb-4" data-aos="zooom-in">
                <img
                  src={heroimg}
                  alt="AzyByte Technologies Tech Professional"
                  className="img-fluid rounded-circle shadow-sm"
                  style={{ width: '250px', height: '250px', objectFit: 'cover' }}
                  data-aos="fade-up"
                />
              </div>

              <div className="d-none d-lg-block">
                <div className="d-flex gap-3 mb-5">
                  <a href="/contact" className="btn btn-primary btn-lg px-4">Get Started</a>
                  <a href="/services" className="btn btn-outline-secondary btn-lg px-4 d-flex align-items-center">
                    Explore all IT Solutions<i className="bi bi-arrow-right ms-2"></i>
                  </a>
                </div>

                {/* --- Stats Section --- */}
                <div className="row g-3 mt-5 pt-2 " data-aos="fade-right">
                  <div className="col-auto me-4">
                    <h3 className="fw-bold text-primary mb-0">30+</h3>
                    <p className="text-muted small">Success Projects</p>
                  </div>
                  <div className="col-auto me-4">
                    <h3 className="fw-bold text-primary mb-0">98%</h3>
                    <p className="text-muted small">Client Satisfaction</p>
                  </div>
                  <div className="col-auto me-4">
                    <h3 className="fw-bold text-primary mb-0">24/7</h3>
                    <p className="text-muted small">Expert Support</p>
                  </div>
                  <div className="col-auto">
                    <h3 className="fw-bold text-primary mb-0">12+</h3>
                    <p className="text-muted small">Global Clients</p>
                  </div>
                </div>
              </div>

            {/* Mobile Version of Stats (Optional: Add inside the mobile div if you want it there too) */}
            <div className="d-lg-none mt-4 px-3">
                <div className="row g-2 justify-content-center border-top pt-3">
                    <div className="col-6" data-aos="zoom-in-left">
                      <h4 className="fw-bold text-primary mb-0">30+</h4>
                        <p className="text-muted x-small">Success Projects</p>
                    </div>
                    <div className="col-6" data-aos="zoom-in-right" >
                        <h4 className="fw-bold text-primary mb-0">12+</h4>
                        <p className="text-muted x-small">Global Clients</p>
                    </div>
                </div>
                  <div className="text-center mt-4" data-aos="fade-up">
              <a
                  href="/contact"
                  className="btn btn-primary btn-lg px-4 py-2 rounded-pill shadow-sm"
              >
                  Contact Us
              </a>
          </div>
            </div>


            </div>

            {/* --- DESKTOP ONLY RIGHT IMAGE --- */}
            {/* Hides on mobile (d-none), shows on Large screens (d-lg-block) */}
            <div className="col-lg-6 d-none d-lg-block" >
              <div className="hero-image-wrapper" >
                <img
                  src={heroimg}
                  alt="AzyByte Technologies Tech Professional"
                  className="img-fluid hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>




      {/* Services Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-6 text-center">
              <h2 className="fw-bold mb-3">Our Services</h2>
              <p className="">We provide cutting-edge technology solutions to help your business thrive in the digital age. Get Connected with
                the AzyByte to make your business and tech solution touch the sky. Make your business grow with us by digitalizing the growth.
              </p>
            </div>
          </div>

          <div className="row g-4">

              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className="bi bi-code-square text-primary"></i>
                    </div>
                    <h5 className="card-title">Web Development</h5>
                    <p className="card-text">Custom web applications and responsive websites tailored to your business needs.</p>
                  </div>
                </div>
              </div>


              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className="bi bi-wordpress text-primary"></i>
                    </div>
                    <h5 className="card-title">Wordpress/Shopify Website Development</h5>
                    <p className="card-text">Professional WordPress solutions, from custom themes to plugin integration. Payment Gateway to Delivery.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                    <i className="bi bi-chat-dots text-primary"></i>                    </div>
                    <h5 className="card-title">ChatBots and Automation</h5>
                    <p className="card-text">End-to-end e-commerce stores designed to convert visitors into customers with seamless shopping experiences.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className="bi bi-phone text-primary"></i>
                    </div>
                    <h5 className="card-title">Mobile App Development</h5>
                    <p className="card-text">Native and cross-platform mobile applications for iOS and Android.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className="bi bi-cpu text-primary"></i>
                    </div>
                    <h5 className="card-title">IOT Development</h5>
                    <p className="card-text">Connecting hardware and software with smart, data-driven IoT ecosystems and embedded systems.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className="bi bi-cloud text-primary"></i>
                    </div>
                    <h5 className="card-title">Cloud Solutions</h5>
                    <p className="card-text">Scalable cloud infrastructure and migration services to optimize your business operations.</p>
                  </div>
                </div>
              </div>

          </div>

        </div>
      </section>



      {/* founder section  */}

      <FounderSection></FounderSection>


      {/* About Section Preview */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={azybytelogo}
                loading="lazy"
                alt="AzyByte Technologies"
                className="img-fluid rounded"
              />
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3">About AzyByte Technologies</h2>
              <p className="mb-4">
                Founded in 2026, AzyByte has been at the forefront of technological innovation,
                helping businesses transform digitally and stay ahead of the competition.
                 Our team of experts brings years of experience in various tech domains,
                ensuring that we deliver solutions that not only meet but exceed client expectations.
                We specialize in helping SMEs transition into tech-enabled businesses, streamline operations, and scale efficiently.
              </p>
                <p className="mb-4">
                By leveraging the power of Artificial Intelligence, we create smarter, faster, and more efficient solutions—from intelligent automation to data-driven
                insights—ensuring our clients achieve better performance and sustainable growth.
              </p>
              <a href="/about" className="btn btn-primary">Learn More About AzyByte Technologies</a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-7 text-center">
              <h6 className="text-primary fw-bold text-uppercase">Why Choose Us</h6>
              <h2 className="fw-bold">Experience Excellence with AzyByte</h2>
              <p className="text-muted">We don't just build software; we build long-term partnerships through reliability and transparency.</p>
            </div>
          </div>

          <div className="row g-4">
            {/* Maintenance Plan */}
            <div className="col-md-6 col-lg-3" data-aos="zoom-in">
              <div className="p-4 border rounded shadow-sm h-100 text-center bg-light-hover transition">
                <div className="mb-3">
                  <i className="bi bi-shield-check fs-1 text-primary"></i>
                </div>
                <h5 className="fw-bold">Free Maintenance</h5>
                <p className="small text-muted">3 times free support & maintenance in the 1st year (at 4, 8, and 12-month intervals).</p>
              </div>
            </div>

            {/* Fast Delivery */}
            <div className="col-md-6 col-lg-3" data-aos="zoom-in">
              <div className="p-4 border rounded shadow-sm h-100 text-center bg-light-hover transition">
                <div className="mb-3">
                  <i className="bi bi-lightning-charge fs-1 text-primary"></i>
                </div>
                <h5 className="fw-bold">Fast Delivery</h5>
                <p className="small text-muted">Optimized workflows and agile development to get your product to market in record time.</p>
              </div>
            </div>

            {/* Low Pricing */}
            <div className="col-md-6 col-lg-3" data-aos="zoom-in">
              <div className="p-4 border rounded shadow-sm h-100 text-center bg-light-hover transition">
                <div className="mb-3">
                  <i className="bi bi-currency-rupee fs-1 text-primary"></i>
                </div>
                <h5 className="fw-bold">Affordable Pricing</h5>
                <p className="small text-muted">Enterprise-grade solutions at competitive rates, tailored to startups and SMEs.</p>
              </div>
            </div>

            {/* 24/7 Problem Support */}
            <div className="col-md-6 col-lg-3" data-aos="zoom-in">
              <div className="p-4 border rounded shadow-sm h-100 text-center bg-light-hover transition">
                <div className="mb-3">
                  <i className="bi bi-headset fs-1 text-primary"></i>
                </div>
                <h5 className="fw-bold">Anytime Support</h5>
                <p className="small text-muted">Encountered a bug? Our team is available 24/7 to handle critical software issues instantly.</p>
              </div>
            </div>

            {/* Scalable Architecture */}
            <div className="col-md-6" data-aos="zoom-out-up">
              <div className="p-4 border rounded shadow-sm h-100 d-flex align-items-center bg-white">
                <i className="bi bi-graph-up-arrow fs-2 text-primary me-4"></i>
                <div>
                  <h5 className="fw-bold mb-1">Scalable Architecture</h5>
                  <p className="small text-muted mb-0">We build systems that grow with your user base, ensuring zero downtime as you expand.</p>
                </div>
              </div>
            </div>

            {/* Transparent Process */}
            <div className="col-md-6" data-aos="zoom-out-down">
              <div className="p-4 border rounded shadow-sm h-100 d-flex align-items-center bg-white">
                <i className="bi bi-eye fs-2 text-primary me-4"></i>
                <div>
                  <h5 className="fw-bold mb-1">Full Transparency</h5>
                  <p className="small text-muted mb-0">Get regular updates and access to staging environments to see your project come to life.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Our Workflow</h2>
            <p className="text-muted">From concept to deployment, we follow a structured path to success.</p>
          </div>
          <div className="row g-4">
            {[
              { step: "01", title: "Discovery", desc: "Consultation to understand your goals, target audience, and technical requirements.", icon: "bi-search" },
              { step: "02", title: "Strategy", desc: "Detailed planning, UI/UX wireframing, and selecting the perfect tech stack for scalability.", icon: "bi-layers" },
              { step: "03", title: "Development", desc: "Agile coding with regular updates, ensuring the product is built exactly as envisioned.", icon: "bi-braces-asterisk" },
              { step: "04", title: "Launch & Support", desc: "Deployment and our signature 4-4-4 maintenance plan to keep your system running.", icon: "bi-rocket-takeoff" }
            ].map((item, index) => (
              <div className="col-md-6 col-lg-3 workflow-div" data-aos={index % 2 === 0 ? "fade-left" : "fade-right"} key={index}>
                <div className="card h-100 border-0 shadow-sm p-4 text-center">
                  <div className="text-primary fw-bold mb-2 fs-5">{item.step}</div>
                  <div className="mb-3">
                    <i className={`bi ${item.icon} fs-2 text-primary`}></i>
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="small text-muted mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


    <section className="py-5 bg-dark text-white">
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-5 mb-5 mb-lg-0" data-aos="fade-right">
            <h6 className="text-primary fw-bold text-uppercase mb-3">Our Competitive Edge</h6>
            <h2 className="display-5 fw-bold mb-4">Why AzyByte is <span className="text-primary">Special</span></h2>
            <p className="lead text-secondary mb-4">
              Most agencies just build; we <strong>defend</strong>. At AzyByte, we integrate
              Cybersecurity into the very DNA of your project.
            </p>
            <p className="text-secondary mb-5">
              Leveraging our developers expertise in Ethical Hacking, we ensure that your digital
              assets are shielded against modern threats from day one.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg rounded-pill px-4">Get Secure Audit</a>
          </div>

          {/* Right Content - Security Features */}
          <div className="col-lg-7">
            <div className="row g-4">
              {[
                {
                  title: "Security Audits",
                  desc: "Comprehensive testing for SQL injection, XSS, and broken authentication.",
                  icon: "bi-shield-lock"
                },
                {
                  title: "End-to-End Encryption",
                  desc: "Ensuring your user data is encrypted at rest and in transit.",
                  icon: "bi-incognito"
                },
                {
                  title: "IoT Hardening",
                  desc: "Specialized security layers for ESP32 and Arduino hardware ecosystems.",
                  icon: "bi-cpu-fill"
                },
                {
                  title: "SSL & Protection",
                  desc: "Automated firewall setup and DDoS mitigation for all web apps.",
                  icon: "bi-safe2"
                }
              ].map((item, index) => (
                <div className="col-md-6" key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                  <div className="p-4 border border-secondary rounded-4 h-100 bg-opacity-10 bg-primary">
                    <i className={`bi ${item.icon} fs-1 text-primary mb-3 d-block`}></i>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="small text-secondary mb-0">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>




      <section id="portfolio" className="py-5 bg-white">
        <div className="container py-4">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="fw-bold">Our Featured Work</h2>
            <p className="text-muted">A glimpse into the digital solutions we've engineered.</p>
          </div>

          <div className="row g-4">

             {/* Project 1: Unityone */}
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
              <div className="card h-300 border-0 shadow-sm overflow-hidden portfolio-card">
                <div className="h-200 p-5 text-center text-dark fw-bold portfolio-img"
                style={{
                      backgroundImage: `url(${unityonehealthcentre})`,
                      backgroundSize: "cover",
                      border: "1px solid #eaeaea",
                      boxShadow: "inset 0 -8px 10px -10px rgba(0,0,0,0.2)",
                    }}>

                </div>
                <div className="card-body">
                  <h5 className="fw-bold"><a href='https://unityonehealthcentre.com' style={{textDecoration:"none",color:"inherit"}}>Unityone Health Centre</a></h5>
                  <p className="text-muted small">An Customized Hospital/Polyclinic Website with booking as per doctors timings and availability.</p>
                  <div className="d-block gap-2">
                    <span className="badge bg-light text-primary border">React</span>
                    <span className="badge bg-light text-primary border">NextJs</span>
                    <span className="badge bg-light text-primary border">Framer Motion</span>
                  </div>
                </div>
              </div>
            </div>


            {/* Project 2: WhatsApp Automation */}
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="card h-200 border-0 shadow-sm overflow-hidden portfolio-card">
                <div className="p-5 text-center text-white fw-bold portfolio-img"
                style={{
                      backgroundImage: `url(${whatsappautomation})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      border: "1px solid #eaeaea",
                      boxShadow: "inset 0 -8px 10px -10px rgba(0,0,0,0.2)"
                    }}>
                </div>
                <div className="card-body">
                  <h5 className="fw-bold">WhatsApp Automation Bot</h5>
                  <p className="text-muted small">AI-powered customer service bot for automated replies for services with menus. Customer sends Initial message, bot gets active and replies with menu for services. </p>
                  <div className="d-block gap-4 col">
                    <span className="badge bg-light text-primary border">Node.js</span>
                    <span className="badge bg-light text-primary border">API</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Project 3: Royal Crown */}
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="200">
              <div className="card h-100 border-0 shadow-sm overflow-hidden portfolio-card">
                <div className="bg-success p-5 text-center text-white fw-bold portfolio-img"
                style={{
                      backgroundImage: `url(${royalcrown})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      border: "1px solid #eaeaea",
                      boxShadow: "inset 0 -8px 10px -10px rgba(0,0,0,0.2)"
                    }}>
                </div>
                <div className="card-body">
                  <h5 className="fw-bold">Royal Crown</h5>
                  <p className="text-muted small">Food Ordering Sytem for Cafe, receive order from customer to kitchen. Generate bill online and pay online with Qr Code functionality.</p>
                  <div className="d-flex gap-2">
                    <span className="badge bg-light text-primary border">PHP</span>
                    <span className="badge bg-light text-primary border">MYSQL</span>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>


      <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our Clients Say</h2>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            // when window width is >= 768px (Tablet)
            768: {
              slidesPerView: 2,
            },
            // when window width is >= 1024px (Laptop)
            1024: {
              slidesPerView: 3,
            },
          }}
          className="pb-5"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="p-4 border rounded-4 shadow-sm bg-white h-100">
                <div className="d-flex mb-3 text-warning">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="bi bi-star-fill me-1"></i>
                  ))}
                </div>
                <p className="fst-italic text-muted">"{review.text}"</p>
                <div className="d-flex align-items-center mt-auto">
                  <div className={`${review.color} text-white rounded-circle p-2 me-3 d-flex align-items-center justify-content-center`}
                       style={{ width: '45px', height: '45px', fontWeight: 'bold' }}>
                    {review.initial}
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold">{review.name}</h6>
                    <small className="text-muted">{review.role}</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>


<section className="home-blog-section py-5 bg-light">

  <div className="container">

    {/* Section Heading */}
    <div className="text-center mb-5">
      <h2 className="fw-bold">
        Latest Insights from AzyByte Technologies
      </h2>

      <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
        Explore our latest articles on web development,
        AI automation, software engineering, digital marketing,
        and business technology solutions.
      </p>
    </div>

    {/* Desktop View */}
    <div className="row g-4 d-none d-md-flex">

      {blogs.slice(0, 3).map((blog) => (
        <div key={blog.id} className="col-md-4">

          <article className="card h-100 border-0 shadow-sm blog-home-card">

            <img
              src={blog.image}
              loading="lazy"
              alt={`${blog.title} - AzyByte Technologies`}
              className="card-img-top"
            />

            <div className="card-body d-flex flex-column">

              <h3 className="h5 fw-bold">
                {blog.title}
              </h3>

              <p className="text-muted small flex-grow-1">
                {blog.description}
              </p>

              <Link
                to={`/blog/${blog.slug}`}
                className="btn btn-primary rounded-pill"
              >
                Read More
              </Link>

            </div>

          </article>

        </div>
      ))}

    </div>

    {/* Mobile Slider */}
    <div className="d-md-none">

      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1.15}
        spaceBetween={15}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false
        }}
      >

        {blogs.slice(0, 3).map((blog) => (
          <SwiperSlide key={blog.id}>

            <article className="card border-0 shadow-sm blog-home-card">

              <img
                src={blog.image}
                loading="lazy"
                alt={`${blog.title} - AzyByte Technologies`}
                className="card-img-top"
              />

              <div className="card-body">

                <h3 className="h5 fw-bold">
                  {blog.title}
                </h3>

                <p className="text-muted small">
                  {blog.description}
                </p>

                <Link
                  to={`/blog/${blog.slug}`}
                  className="btn btn-primary rounded-pill"
                >
                  Read More
                </Link>

              </div>

            </article>

          </SwiperSlide>
        ))}

      </Swiper>

    </div>

    {/* View All Blogs */}
    <div className="text-center mt-5">
      <Link
        to="/blog"
        className="btn btn-outline-primary rounded-pill px-4"
      >
        View All Blogs
      </Link>
    </div>

  </div>

</section>

        {/* FAQ Section */}
    <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold mb-3">Frequently Asked Questions</h2>
              <p className="mb-0">
                Find quick answers to some common questions about working with us.
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="accordion" id="faqAccordion">
                <div className="accordion-item border-0 shadow-sm mb-3">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      How long does it typically take to complete a project?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      Project timelines vary depending on the scope and complexity. A simple website might take 2-4 weeks, while a complex web application could take 2-6 months. During our initial consultation, we'll provide a detailed timeline based on your specific requirements.
                    </div>
                  </div>
                </div>

                <div className="accordion-item border-0 shadow-sm mb-3">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      What is your pricing structure?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      We offer flexible pricing models including fixed-price projects, hourly rates, and retainer arrangements. The best model depends on your project's requirements and scope. We provide detailed quotes after understanding your project needs during our initial consultation.
                    </div>
                  </div>
                </div>

                <div className="accordion-item border-0 shadow-sm mb-3">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Do you provide ongoing support after project completion?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      Yes, we offer various maintenance and support packages to ensure your solution continues to run smoothly after launch. Our support options include regular updates, bug fixes, feature enhancements, and performance monitoring.
                    </div>
                  </div>
                </div>

                <div className="accordion-item border-0 shadow-sm mb-3">
                  <h2 className="accordion-header" id="headingFour">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                      What technologies do you specialize in?
                    </button>
                  </h2>
                  <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      We specialize in a wide range of technologies including React, Angular, Vue.js, Node.js, Python, PHP, AWS, Azure, and more. Our team stays up-to-date with the latest technology trends to ensure we're providing the most effective solutions for our clients.
                    </div>
                  </div>
                </div>

                <div className="accordion-item border-0 shadow-sm">
                  <h2 className="accordion-header" id="headingFive">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                      How do you handle project communication?
                    </button>
                  </h2>
                  <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      We believe in transparent and regular communication. Depending on your preference, we set up weekly or bi-weekly progress meetings, provide access to project management tools, and assign a dedicated project manager who serves as your main point of contact throughout the project.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

  </main>
  <footer>
    <Footer />
  </footer>
</div>

  );
}

export default AzyByteLanding;